(function () {
  'use strict';

  // Eva & Leo London — pre-order waitlist.
  //
  // Listens for the 'mto:size' event that mto-customizer.js announces, so this
  // file holds no copy of the size rules and can be removed without touching
  // the configurator. It never reads or writes the cart form.

  var PENDING = 'mto-waitlist-pending';

  var root, form, tagsInput, sizeEl, errorEl, bodyEl, doneEl, openBtn;
  var lastFocus = null, currentSize = '';

  // Shopify tags are matched exactly in the admin, so they have to be built the
  // same way every time. Lower case, and anything that is not a letter, digit
  // or dash becomes a dash, which is what handleize does to the product handle.
  function slug(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function init() {
    root = document.querySelector('[data-mto-waitlist]');
    if (!root) return;

    form      = root.querySelector('form');
    tagsInput = root.querySelector('[data-mto-wl-tags]');
    sizeEl    = root.querySelector('[data-mto-wl-size]');
    errorEl   = root.querySelector('[data-mto-wl-error]');
    bodyEl    = root.querySelector('[data-mto-wl-body]');
    doneEl    = root.querySelector('[data-mto-wl-done]');
    openBtn   = document.querySelector('[data-mto-waitlist-open]');

    document.addEventListener('mto:size', function (event) {
      setSize(event.detail.soldOut ? event.detail.label : '');
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-mto-waitlist-open]')) { open(); return; }
      if (event.target.closest('[data-mto-wl-close]'))      { close(); }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) close();
    });

    if (form) {
      form.addEventListener('submit', function () {
        remember();
        var button = form.querySelector('.mto-wl__submit');
        if (button) button.textContent = 'Joining…';
        // Not prevented: Shopify's own submit is what carries the captcha.
        stall();
      });
    }

    showResult();
  }

  // Swapping which button is visible rather than relabelling the real one: the
  // add-to-basket button is the page's submit control and mto-customizer.js
  // owns its disabled state, so it is left exactly as it is.
  function setSize(label) {
    currentSize = label || '';
    var cta = document.querySelector('.mto-cta');
    if (openBtn) openBtn.hidden = !currentSize;
    if (cta) cta.hidden = !!currentSize;
    if (currentSize && sizeEl) sizeEl.textContent = 'Size ' + currentSize + ' — sold out';
    if (currentSize && tagsInput) {
      // Three tags, broadest first, so the customer list filters at any level:
      // everyone waiting, everyone waiting for this blazer, and this blazer in
      // this size.
      var name = slug(root.dataset.mtoProduct || '');
      tagsInput.value = 'waitlist, waitlist-' + name + ', waitlist-' + name + '-' + slug(currentSize);
    }
  }

  function open() {
    if (!currentSize) return;
    openPanel();
  }

  function openPanel() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('mto-wl-open');
    // On the way back from a successful post the form is hidden, so focus the
    // only control there is rather than an input nobody can see.
    var field = bodyEl && !bodyEl.hidden
      ? root.querySelector('.mto-wl__input')
      : root.querySelector('[data-mto-wl-done] .mto-wl__submit');
    if (field) field.focus();
  }

  function close() {
    root.hidden = true;
    document.body.classList.remove('mto-wl-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Submitted the ordinary way, with a page load.
  //
  // Posting it in the background was tried first, to keep the customer's
  // configuration on screen, and it cannot work: the shop has Shopify's spam
  // protection on, so /contact answers a background post with 400 "Missing
  // CAPTCHA token", and the captcha it wants is a challenge served from another
  // domain that only the real form submission can carry. Fighting that would
  // mean turning the shop's spam protection off, which is a worse trade than a
  // page load. The size is put aside first so the result can be shown when the
  // page comes back.
  function remember() {
    try {
      sessionStorage.setItem(PENDING, currentSize || '');
    } catch (e) {
      // Private browsing can refuse storage. The signup still goes through;
      // only the confirmation on the way back is lost, so there is nothing to
      // do about it here.
    }
  }

  // Shopify's spam protection stops the submit, fetches a captcha token and
  // sends the form on. If that never finishes, the page simply does not go
  // anywhere - and without this the button would sit on "Joining…" for ever
  // with nothing said. After a wait the form is handed back with a way to
  // reach a person, which is better than a dead button whatever the cause.
  function stall() {
    setTimeout(function () {
      if (root.hidden || (doneEl && !doneEl.hidden)) return;
      var button = form.querySelector('.mto-wl__submit');
      if (button) button.textContent = 'Join the waitlist';
      if (errorEl) {
        errorEl.innerHTML = 'That did not go through. Please email ' +
          '<a href="mailto:concierge@evaandleolondon.com">concierge@evaandleolondon.com</a>' +
          ' and we will add you to the list.';
        errorEl.hidden = false;
      }
      try { sessionStorage.removeItem(PENDING); } catch (e) {}
    }, 9000);
  }

  // Both this and the footer newsletter are customer forms, and Shopify marks
  // every customer form on the page as posted after any one of them is sent.
  // The note left above is what says this one was the form submitted.
  function showResult() {
    var pending;
    try {
      pending = sessionStorage.getItem(PENDING);
      sessionStorage.removeItem(PENDING);
    } catch (e) {
      return;
    }
    if (pending === null) return;

    var result = root.querySelector('[data-mto-wl-result]');
    if (!result) return;

    currentSize = pending;
    if (result.dataset.haserrors === 'true') {
      if (errorEl) errorEl.hidden = false;
      openPanel();
    } else if (result.dataset.posted === 'true') {
      done();
      openPanel();
    }
  }

  function done() {
    var note = root.querySelector('[data-mto-wl-done-note]');
    if (note && currentSize) {
      note.textContent = 'We will email you before the next run of size ' +
                         currentSize + ' opens.';
    }
    if (bodyEl) bodyEl.hidden = true;
    if (doneEl) doneEl.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
